export function FontSize (pEditor)
{
  let prevFontSize,
      currentFontSizeIds,
      currentFontSizeMarker;
  
  
  function getCurrentFontSize(isInt = true)
  {
    let fontSize;

    if (BEditor.browser.isIE && ((pEditor.pToolbar && pEditor.pToolbar.isMouseDown) || pEditor.isDropdownOpen) && prevFontSize != null)
    {
      return prevFontSize;
    }

    if (currentFontSizeIds != null)
    {
      fontSize = currentFontSizeIds;
    }
    else
    {
      fontSize = pEditor.style.helpers.getCurrentStyleInRange('fontSize');
    }

    if (fontSize)
    {
      fontSize = isInt ? parseInt(fontSize, 10) : parseFloat(fontSize);
      fontSize = (isNaN(fontSize) ? 'Size' : fontSize);
    }
    else
    {
      fontSize = '';
    }

    prevFontSize = fontSize;
    return fontSize;
  }


  this.openFontSizeDropdown = (pButton) =>
  {
    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', '');
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'setFontSize');
    }
  };
  

  function setFontSize (pButton, fontSize)
  {
    let pParameters,
        fontSizeIds,
        currentRange,
        isSaveCurrentRangeCollapsed,
        currentFontSize,
        marker;

    pEditor.pDropdown = pButton.getDropdown();

    if (fontSize)
    {
      fontSizeIds = fontSize;
    }
    else
    {
      if (pEditor.pDropdown)
      {
        pParameters = pEditor.pDropdown.getReturnedParameters();
      }

      if (pParameters && pParameters.selectedStyleId)
      {
        fontSizeIds = pParameters.selectedStyleId;
      }

      pEditor.closeDropdown(pButton);
    }

    if (fontSizeIds)
    {
      pEditor.range.stopCheckSelection();

      if (!BEditor.browser.isIE)
      {
        pEditor.iFrameDoc.execCommand('styleWithCSS', false, false);
      }

      currentRange = pEditor.range.getCurrent();
      isSaveCurrentRangeCollapsed = currentRange.collapsed;

      currentFontSize = getCurrentFontSize();
      marker = currentFontSize ? ((currentFontSize < 30) ? 7 : 2) : 7;

      collectFontSizeTags(marker, fontSizeIds);
      pEditor.iFrameDoc.execCommand('fontsize', false, marker);

      if (isSaveCurrentRangeCollapsed)
      {
        currentFontSizeIds = fontSizeIds;
        currentFontSizeMarker = marker;
        BEditor.domHandlers.addHandler(pEditor.iFrameDoc.body, 'keypress', changeFontSizeTag);
        BEditor.domHandlers.addHandler(pEditor.iFrameDoc.body, 'mousedown', clearCurrentFontSizeIds);
        pEditor.pThis.addHandler('blur', clearCurrentFontSizeIds, 'clearCurrentFontSizeIds');
      }

      restoreFontSizeTags(marker, fontSizeIds);
      pEditor.range.restoreBookmark();
    }
    else
    {
      return false;
    }
  }


  function changeFontSizeTag ()
  {
    BEditor.domHandlers.removeHandler(pEditor.iFrameDoc.body, 'keypress', changeFontSizeTag);
    setTimeout(changeFontSizeTagDo, 17);
  }


  function changeFontSizeTagDo ()
  {
    if (currentFontSizeIds == null)
    {
      return false;
    }

    restoreFontSizeTags(currentFontSizeMarker, currentFontSizeIds);
  }


  function clearCurrentFontSizeIds ()
  {
    currentFontSizeIds = null;
    pEditor.pThis.removeHandler('blur', 'clearCurrentFontSizeIds');
  }


  function collectFontSizeTags (marker, currentFontSize)
  {
    let i,
        fontFace,
        attrSize,
        fontSize,
        currentMarker,
        elements = pEditor.iFrameDoc.body.querySelectorAll('FONT[style*="font-size:"], FONT[size]');

    for (i = elements.length; i--;)
    {
      fontSize = BEditor.styleHelpers.getElementStyleInt(elements[i], 'fontSize', pEditor.iFrame);
      fontFace = elements[i].getAttribute('face') || '0';
      attrSize = elements[i].getAttribute('size') || '0';
      currentMarker = fontSize ? ((fontSize < 20) ? 6 : 1) : 1;

      elements[i].setAttribute('face', 'WaFontMarkTag-WA-' + fontFace + '-WA-' + fontSize + '-WA-' + attrSize);
      elements[i].setAttribute('size', ((fontSize == currentFontSize) ? marker : currentMarker));

      if (fontSize)
      {
        elements[i].style.fontSize = '';

        if (elements[i].getAttribute('style') == '')
        {
          elements[i].removeAttribute('style');
        }
      }
    }
  }


  function restoreFontSizeTags (marker, currentFontSize)
  {
    let i,
        cssDefaultFontSize = {'xx-small': 1, 'x-small': 1, 'small': 2, 'medium': 3, 'large': 4, 'x-large': 5, 'xx-large': 6},
        attributes,
        attrFace,
        fontSize,
        parentElement,
        isParentFace,
        elements = pEditor.iFrameDoc.body.querySelectorAll('[style*="font-size:"]');

    for (i = 0; i < elements.length; i++)
    {
      fontSize = elements[i].style.fontSize.toLowerCase();

      if (fontSize && fontSize in cssDefaultFontSize)
      {
        elements[i].style.removeProperty('font-size');
        elements[i].innerHTML = '<font size="' + cssDefaultFontSize[fontSize] + '">' + elements[i].innerHTML + '</font>';
      }
    }

    elements = pEditor.iFrameDoc.body.querySelectorAll('FONT[size]');

    for (i = elements.length; i--;)
    {
      attrFace = elements[i].getAttribute('face');
      fontSize = elements[i].getAttribute('size');

      isParentFace = false;

      if (!attrFace && fontSize != marker)
      {
        parentElement = elements[i].parentNode;
        isParentFace = true;

        while (!attrFace && parentElement && parentElement.nodeName !== 'BODY')
        {
          attrFace = parentElement.getAttribute('face');
          parentElement = parentElement.parentNode;
        }
      }

      attributes = attrFace ? attrFace.split('-WA-') : null;

      if (attributes && attributes.length === 4)
      {
        if (!isParentFace)
        {
          if (attributes[1] && attributes[1] != 0)
          {
            elements[i].setAttribute('face', attributes[1]);
          }
          else
          {
            elements[i].removeAttribute('face');
          }
        }

        if (fontSize)
        {
          if (attributes[2] && attributes[2] != 0)
          {
            if (fontSize == marker)
            {
              elements[i].setAttribute('data-wasetfontsize', '1');
              elements[i].style.fontSize = currentFontSize + 'px';
            }
            else
            {
              elements[i].style.fontSize = attributes[2] + 'px';
            }

            elements[i].removeAttribute('size');
          }
          else if (attributes[3] && attributes[3] != 0)
          {
            elements[i].setAttribute('size', attributes[3]);
          }
          else
          {
            elements[i].removeAttribute('size');
          }
        }
      }
      else
      {
        fontSize = elements[i].getAttribute('size');

        if (fontSize == marker)
        {
          elements[i].setAttribute('data-wasetfontsize', '1');
          elements[i].style.fontSize = currentFontSize + 'px';
          elements[i].removeAttribute('size');
        }
      }

      if (elements[i].outerHTML.substr(0, 6).toUpperCase().indexOf('<FONT>') === 0)
      {
        elements[i].outerHTML = elements[i].innerHTML;
      }
    }

    elements = pEditor.iFrameDoc.body.querySelectorAll('FONT[face*="WaFontMarkTag"]');

    for (i = elements.length; i--;)
    {
      attributes = elements[i].getAttribute('face').split('-WA-');

      if (attributes && attributes.length > 1)
      {
        if (attributes[1] && attributes[1] != 0)
        {
          elements[i].setAttribute('face', attributes[1]);
        }
        else
        {
          elements[i].removeAttribute('face');
        }
      }
      else
      {
        elements[i].removeAttribute('face');
      }

      if (elements[i].outerHTML.substr(0, 6).toUpperCase().indexOf('<FONT>') === 0)
      {
        elements[i].outerHTML = elements[i].innerHTML;
      }
    }

    elements = pEditor.iFrameDoc.body.querySelectorAll('[data-wasetfontsize]');

    if (elements && elements.length)
    {
      pEditor.range.setCursorPoint(elements[elements.length - 1], false);
    }

    for (i = 0; i < elements.length; i++)
    {
      elements[i].removeAttribute('data-wasetfontsize');
    }
  }
  
  
  this.getCurrentFontSize = getCurrentFontSize;
  this.setFontSize = setFontSize;
}